
const Section2 = () => {
  return (
    <div className="component-section-2-home">
      <img src="/assets/logo/logo-2.png" alt="logo BLR" className="logo" />
      <div className="container-text">
        <div className="text">Cadre imprégné de l&rsquo;esprit des bistrots d&rsquo;antan.</div>
        <div className="text">À l&rsquo;entrée, petit comptoir accueillant.</div>
        <div className="text">Dans la salle, affiches chinées au fil du temps, baie vitrée donnant sur la terrasse où il fait bon s&rsquo;attabler dès les premiers soleils.</div>
        <div className="text">La cuisine décline les saveurs traditionnelles saupoudrées de quelques pincées de modernité.</div>
        <div className="text">Situé en plein Bois le roi.</div>
      </div>
    </div>
  )
}

export default Section2